import React from "react";
import { Card, CardBody, Container } from "reactstrap";
import Breadcrumbs from "../Common/Breadcrumb";
import Dropzone from "react-dropzone";
import { withTranslation } from "react-i18next";

const ViewUserDetail = () => {
  document.title = "add user";
  return (
    <div className="page-content">
      <Container fluid={true}>
        <Breadcrumbs
          title="party"
          className="text-black"
          breadcrumbItem="MANAGE USER"
        />
        <Card>
          <CardBody>
            <div className="d-flex flex-row justify-content-between">
              <div>
                <h4 className="text-black fw-bold mb-4">View User Details</h4>
              </div>
              <div>
                <div className="d-inline-block me-3 fs-5 fw-bold">Disabled</div>
                <div className="form-check form-switch d-inline-block">
                  <input
                    type="checkbox"
                    className="form-check-input"
                    id="site_state"
                    disabled
                  />
                  <label
                    htmlFor="site_state"
                    className="form-check-label pt-4"
                  ></label>
                </div>
              </div>
            </div>
            <form>
              <div className="mb-3 row">
                <label
                  htmlFor="example-number-input"
                  className="col-md-2 col-form-label"
                >
                  <h5 className="text-secondary fw-bold"> {this.props.t("User Photo")} </h5>
                </label>
                <div className="col-md-10">
                  <Dropzone
                    onDrop={acceptedFiles =>
                      this.handleAcceptedFiles(acceptedFiles)
                    }
                  >
                    {({ getRootProps, getInputProps }) => (
                      <div className="dropzone">
                        <div
                          className="dz-message needsclick"
                          {...getRootProps()}
                        >
                          <input {...getInputProps()} disabled/>
                          <div className="mb-3">
                            <i className="display-4 text-muted bx bxs-cloud-upload" />
                          </div>
                          <h4>Drop logo here or click to upload.</h4>
                        </div>
                      </div>
                    )}
                  </Dropzone>
                </div>
              </div>
              <div className="mb-3 row">
                <label
                  htmlFor="example-text-input"
                  className="col-md-2 col-form-label"
                >
                  <h5 className="text-secondary fw-bold"> {this.props.t("User Name")} </h5>
                </label>
                <div className="col-md-10">
                  <input
                    className="form-control fs-5"
                    type="text"
                    placeholder="XYZ Diamond"
                    disabled
                  />
                </div>
              </div>
              <div className="mb-3 row">
                <label
                  htmlFor="example-text-input"
                  className="col-md-2 col-form-label"
                >
                  <h5 className="text-secondary fw-bold"> Employee Code </h5>
                </label>
                <div className="col-md-10">
                  <input
                    className="form-control fs-5"
                    type="text"
                    placeholder="ADM00001"
                    disabled
                  />
                </div>
              </div>
              <div className="mb-3 row">
                <label className="col-md-2 col-form-label">
                  <h5 className="text-secondary fw-bold"> {this.props.t("User Role")} </h5>
                </label>
                <div className="col-md-10">
                  <select
                    className="form-select fs-5 text-secondary"
                    name="states"
                    disabled
                  >
                    <option disabled value="">
                      select user Role
                    </option>
                    <option value="dataentry">Data Entry</option>
                    <option value="grader"> Grader </option>
                    <option value="filler">Filler</option>
                    <option value="machineoprator">Machine Operator</option>
                    <option value="boilman">Boil Man</option>
                  </select>
                </div>
              </div>
              <div className="mb-3 row">
                <label className="col-md-2 col-form-label">
                  <h5 className="text-secondary fw-bold">{this.props.t("Factory(Unit) Name")}</h5>
                </label>
                <div className="col-md-10">
                  <select
                    className="form-select fs-5 text-secondary"
                    name="states"
                    disabled
                  >
                    <option disabled value="">
                      select factory Name
                    </option>
                    <option value="xyzParty">XYZ Diamond</option>
                    <option value="xyzParty">XYZ Diamond</option>
                    <option value="xyzParty">XYZ Diamond</option>
                    <option value="xyzParty">XYZ Diamond</option>
                  </select>
                </div>
              </div>
              <div className="mb-3 row">
                <label className="col-md-2 col-form-label">
                  <h5 className="text-secondary fw-bold">{this.props.t("User Time Shift")}</h5>
                </label>
                <div className="col-md-10">
                  <select
                    className="form-select fs-5 text-secondary"
                    name="states"
                    disabled
                  >
                    <option disabled value="">
                      select factory Name
                    </option>
                    <option value="xyzParty">
                      Shift-1 (7:00 AM To 3:00 PM)
                    </option>
                    <option value="xyzParty">
                      Shift-2 (7:00 AM To 3:00 PM)
                    </option>
                    <option value="xyzParty">
                      Shift-3 (7:00 AM To 3:00 PM)
                    </option>
                  </select>
                </div>
              </div>
              <div className="mb-3 row">
                <label
                  htmlFor="example-text-input"
                  className="col-md-2 col-form-label"
                >
                  <h5 className="text-secondary fw-bold">Mobile no.1</h5>
                </label>
                <div className="col-md-10">
                  <input
                    className="form-control fs-5"
                    type="tel"
                    disabled
                    name="mobile1"
                    placeholder="Enter only numbers"
                  />
                </div>
              </div>
              <div className="mb-3 row">
                <label
                  htmlFor="example-text-input"
                  className="col-md-2 col-form-label"
                >
                  <h5 className="text-secondary fw-bold">Mobile no.2</h5>
                </label>
                <div className="col-md-10">
                  <input
                    className="form-control fs-5"
                    type="tel"
                    name="mobile2"
                    placeholder="Enter only numbers"
                    disabled
                  />
                </div>
              </div>
              <div className="mb-3 row">
                <label
                  htmlFor="example-email-input"
                  className="col-md-2 col-form-label"
                >
                  <h5 className="text-secondary fw-bold">Email ID</h5>
                </label>
                <div className="col-md-10">
                  <input
                    className="form-control fs-5"
                    type="email"
                    name="email"
                    placeholder="Enter a valid Email ID"
                    disabled
                  />
                </div>
              </div>

              <div className="mb-3 row">
                <label
                  htmlFor="example-text-input"
                  className="col-md-2 col-form-label"
                >
                  <h5 className="text-secondary fw-bold"> Address line 1 </h5>
                </label>
                <div className="col-md-10">
                  <input
                    className="form-control fs-5"
                    type="text"
                    disabled
                    name="address1"
                    placeholder="Address line 1"
                  />
                </div>
              </div>
              <div className="mb-3 row">
                <label
                  htmlFor="example-text-input"
                  className="col-md-2 col-form-label"
                >
                  <h5 className="text-secondary fw-bold"> Address line 2 </h5>
                </label>
                <div className="col-md-10">
                  <input
                    className="form-control fs-5"
                    type="text"
                    disabled
                    name="address2"
                    placeholder="Address line 2"
                  />
                </div>
              </div>
              <div className="mb-3 row">
                <label
                  htmlFor="example-text-input"
                  className="col-md-2 col-form-label"
                >
                  <h5 className="text-secondary fw-bold"> City </h5>
                </label>
                <div className="col-md-10">
                  <input
                    className="form-control fs-5"
                    type="text"
                    disabled
                    name="city"
                    placeholder="City"
                  />
                </div>
              </div>
              
              <div className="mb-3 row">
                <label className="col-md-2 col-form-label">
                  <h5 className="text-secondary fw-bold"> State </h5>
                </label>
                <div className="col-md-10">
                  <select
                    className="form-select fs-5 text-secondary"
                    name="states"
                    disabled
                  >
                    <option value="" disabled>select</option>
                    <option value="Gujarat">Gujarat</option>
                    <option value="Maharashtra">Maharashtra</option>
                    <option value="Tamil Nadu">Tamil Nadu</option>
                    <option value="Uttar Pradesh">Uttar Pradesh</option>
                    <option value="West Bengal">West Bengal</option>
                    <option value="Karnataka">Karnataka</option>
                    <option value="Rajasthan">Rajasthan</option>
                    <option value="Andhra Pradesh">Andhra Pradesh</option>
                    <option value="Madhya Pradesh">Madhya Pradesh</option>
                  </select>
                </div>
              </div>
              <div className="mb-3 row">
                <label
                  htmlFor="example-number-input"
                  className="col-md-2 col-form-label"
                >
                  <h5 className="text-secondary fw-bold">User Notes</h5>
                </label>
                <div className="col-md-10">
                  <textarea
                    className="form-control"
                    type="text-area"
                    name="notes"
                    rows="8"
                    disabled
                  />
                </div>
              </div>
              <div className="col-md-12 text-end">
                <input
                  type="submit"
                  value="Back"
                  className="btn btn-primary w-xl fs-5"
                />
              </div>
            </form>
          </CardBody>
        </Card>
      </Container>
    </div>
  );
};

export default withTranslation()(ViewUserDetail);

// import React, { Component, createRef } from "react";
// import Dropzone from "react-dropzone";

// import {
//   Button,
//   Card,
//   CardBody,
//   Col,
//   Container,
//   Label,
//   Row,
// } from "reactstrap";

// import {Field, Form} from "formik";

// //Import Breadcrumb
// import Breadcrumbs from "../../components/Common/Breadcrumb";

// class ViewUserDetail extends Component {
//   constructor(props) {
//     super(props);

//   }

//    render() {
//     //meta title
//     document.title =
//       "add user";
//     return (
//       <React.Fragment>
//         <div className="page-content">
//           <Container fluid={true}>
//             <Breadcrumbs breadcrumbItem={this.props.t("Manage User")} />
//             <Row>
//               <Col xl="12">
//                 <Card>
//                   <CardBody>
//                   <div className="d-flex flex-row mb-4 justify-content-between">
//                       <div>
//                         <h4 className="text-black fw-bold mb-4">
//                         Edit User Details
//                         </h4>
//                       </div>
//                       <div>
//                         <div className="d-inline-block me-3 fs-5 fw-bold">
//                         Disabled
//                         </div>
//                         <div className="form-check form-switch d-inline-block">
//                           <input
//                             type="checkbox"
//                             className="form-check-input"
//                             id="site_state"
//                             disabled
//                           />
//                           <label
//                             htmlFor="site_state"
//                             className="form-check-label pt-4"
//                           ></label>
//                         </div>
//                       </div>
//                     </div>

//                         <Form className="needs-validation">
//                           <Row>
//                             <div className="mb-3 row">
//                               <label
//                                 htmlFor="example-number-input"
//                                 className="col-md-2 col-form-label"
//                               >
//                                 <h5 className="text-secondary fw-bold">
//                                   {this.props.t("User Photo")}
//                                 </h5>
//                               </label>
//                               <div className="col-md-10">
//                                 <Dropzone
//                                   onDrop={acceptedFiles =>
//                                     this.handleAcceptedFiles(acceptedFiles)
//                                   }
//                                 >
//                                   {({ getRootProps, getInputProps }) => (
//                                     <div className="dropzone">
//                                       <div
//                                         className="dz-message needsclick"
//                                         {...getRootProps()}
//                                       >
//                                         <input {...getInputProps()} />
//                                         <div className="mb-3">
//                                           <i className="display-4 text-muted bx bxs-cloud-upload" />
//                                         </div>
//                                         <h4>
//                                           Drop logo here or click to upload.
//                                         </h4>
//                                       </div>
//                                     </div>
//                                   )}
//                                 </Dropzone>
//                               </div>
//                             </div>
//                             <div className="mb-3 row">
//                               <Label
//                                 htmlFor="userName"
//                                 className="col-md-2 col-form-label"
//                               >
//                                 <h5 className="text-secondary fw-bold">
//                                   {this.props.t("User Name")}
//                                 </h5>
//                               </Label>
//                               <div className="col-md-10">
//                                 <Field
//                                   className="form-control fs-5"
//                                   type="text"
//                                   name="userName"
//                                   placeholder="XYZ Diamond"
//                                 />
//                               </div>
//                             </div>
//                             <div className="mb-3 row">
//                               <Label
//                                 htmlFor="employeecode"
//                                 className="col-md-2 col-form-label"
//                               >
//                                 <h5 className="text-secondary fw-bold">
//                                   Employee Code
//                                 </h5>
//                               </Label>
//                               <div className="col-md-10">
//                                 <Field
//                                   className="form-control fs-5"
//                                   type="text"
//                                   name="employeecode"
//                                   placeholder="ADM00001"
//                                 />
//                               </div>
//                             </div>
//                             <div className="mb-3 row">
//                               <Label
//                                 htmlFor="userRole"
//                                 className="col-md-2 col-form-label"
//                               >
//                                 <h5 className="text-secondary fw-bold">
//                                   User Role
//                                 </h5>
//                               </Label>
//                               <div className="col-md-10">
//                                 <Field
//                                   className="form-control fs-5"
//                                   name="userRole"
//                                   as="select"
//                                 >
//                                   <option disabled value="">
//                                     select user Role
//                                   </option>
//                                   <option value="dataentry">Data Entry</option>
//                                   <option value="grader"> Grader </option>
//                                   <option value="filler">Filler</option>
//                                   <option value="machineoprator">
//                                     Machine Operator
//                                   </option>
//                                   <option value="boilman">Boil Man</option>
//                                 </Field>
//                                 </div>
//                             </div>
//                             <div className="mb-3 row">
//                               <Label
//                                 htmlFor="factoryname"
//                                 className="col-md-2 col-form-label"
//                               >
//                                 <h5 className="text-secondary fw-bold">
//                                   {this.props.t("Factory(Unit) Name")}
//                                 </h5>
//                               </Label>
//                               <div className="col-md-10">
//                                 <Field
//                                   className="form-control fs-5"
//                                   name="factoryname"
//                                   as="select"
//                                 >
//                                   <option disabled value="">
//                                     select factory Name
//                                   </option>
//                                   <option value="xyzParty">
//                                     XYZ Diamond
//                                   </option>
//                                   <option value="xyzParty">
//                                     XYZ Diamond
//                                   </option>
//                                   <option value="xyzParty">
//                                     XYZ Diamond
//                                   </option>
//                                   <option value="xyzParty">
//                                     XYZ Diamond
//                                   </option>
//                                 </Field>
//                                 </div>
//                             </div>
//                             <div className="mb-3 row">
//                               <Label
//                                 htmlFor="timeshift"
//                                 className="col-md-2 col-form-label"
//                               >
//                                 <h5 className="text-secondary fw-bold">
//                                   {this.props.t("User Time Shift")}
//                                 </h5>
//                               </Label>
//                               <div className="col-md-10">
//                                 <Field
//                                   className="form-control fs-5"
//                                   name="timeshift"
//                                   as="select"
//                                 >
//                                   <option disabled value="">
//                                     select factory Name
//                                   </option>
//                                   <option value="xyzParty">
//                                     Shift-1 (7:00 AM To 3:00 PM)
//                                   </option>
//                                   <option value="xyzParty">
//                                     Shift-2 (7:00 AM To 3:00 PM)
//                                   </option>
//                                   <option value="xyzParty">
//                                     Shift-3 (7:00 AM To 3:00 PM)
//                                   </option>
//                                 </Field>
//                               </div>
//                             </div>
//                             <div className="mb-3 row">
//                               <Label
//                                 htmlFor="mobile1"
//                                 className="col-md-2 col-form-label"
//                               >
//                                 <h5 className="text-secondary fw-bold">
//                                   Mobile no.1
//                                 </h5>
//                               </Label>
//                               <div className="col-md-10">
//                                 <Field
//                                   className="form-control fs-5"
//                                   type="number" onWheel={(e) => e.target.blur()}
//                                   name="mobile1"
//                                   placeholder="+91 (132)(564)(9872)"
//                                 />
//                               </div>
//                             </div>
//                             <div className="mb-3 row">
//                               <Label
//                                 htmlFor="mobile2"
//                                 className="col-md-2 col-form-label"
//                               >
//                                 <h5 className="text-secondary fw-bold">
//                                   Mobile no.2
//                                 </h5>
//                               </Label>
//                               <div className="col-md-10">
//                                 <Field
//                                   className="form-control fs-5"
//                                   type="number" onWheel={(e) => e.target.blur()}
//                                   name="mobile2"
//                                   placeholder="+91 (132)(564)(9872)"
//                                 />
//                               </div>
//                             </div>
//                             <div className="mb-3 row">
//                               <Label
//                                 htmlFor="email"
//                                 className="col-md-2 col-form-label"
//                               >
//                                 <h5 className="text-secondary fw-bold">
//                                   Email ID
//                                 </h5>
//                               </Label>
//                               <div className="col-md-10">
//                                 <Field
//                                   className="form-control fs-5"
//                                   type="email"
//                                   name="email"
//                                   placeholder="xyzdiamond123@gmail.com"
//                                 />
//                               </div>
//                             </div>
//                             <div className="mb-3 row">
//                               <Label
//                                 htmlFor="newpassword"
//                                 className="col-md-2 col-form-label"
//                               >
//                                 <h5 className="text-secondary fw-bold">
//                                   {this.props.t("New Password")}
//                                 </h5>
//                               </Label>
//                               <div className="col-md-10">
//                                 <Field
//                                   className="form-control fs-5"
//                                   type="password"
//                                   name="newpassword"
//                                   placeholder="************"
//                                 />
//                               </div>
//                             </div>
//                             <div className="mb-3 row">
//                               <Label
//                                 htmlFor="confirmpassword"
//                                 className="col-md-2 col-form-label"
//                               >
//                                 <h5 className="text-secondary fw-bold">
//                                   {this.props.t("Confirm Password")}
//                                 </h5>
//                               </Label>
//                               <div className="col-md-10">
//                                 <Field
//                                   className="form-control fs-5"
//                                   type="password"
//                                   name="confirmpassword"
//                                   placeholder="************"
//                                 />
//                               </div>
//                             </div>
//                             <div className="mb-3 row">
//                               <Label
//                                 htmlFor="address1"
//                                 className="col-md-2 col-form-label"
//                               >
//                                 <h5 className="text-secondary fw-bold">
//                                   Address line 1
//                                 </h5>
//                               </Label>
//                               <div className="col-md-10">
//                                 <Field
//                                   className="form-control fs-5"
//                                   type="text"
//                                   name="address1"
//                                   placeholder="1901 Thornridge Cir. Shiloh, Hawaii 81063"
//                                 />
//                               </div>
//                             </div>
//                             <div className="mb-3 row">
//                               <Label
//                                 htmlFor="address2"
//                                 className="col-md-2 col-form-label"
//                               >
//                                 <h5 className="text-secondary fw-bold">
//                                   Address line 2
//                                 </h5>
//                               </Label>
//                               <div className="col-md-10">
//                                 <Field
//                                   className="form-control fs-5"
//                                   type="text"
//                                   name="address2"
//                                   placeholder="1901 Thornridge Cir. Shiloh, Hawaii 81063"
//                                 />
//                               </div>
//                             </div>
//                             <div className="mb-3 row">
//                               <Label
//                                 htmlFor="city"
//                                 className="col-md-2 col-form-label"
//                               >
//                                 <h5 className="text-secondary fw-bold">{this.props.t('City')}</h5>
//                               </Label>
//                               <div className="col-md-10">
//                                 <Field
//                                   className="form-control fs-5"
//                                   type="text"
//                                   name="city"
//                                   placeholder="Surat"
//                                 />
//                               </div>
//                             </div>
//                             <div className="mb-3 row">
//                               <Label
//                                 htmlFor="state"
//                                 className="col-md-2 col-form-label"
//                               >
//                                 <h5 className="text-secondary fw-bold">
//                                 State
//                                 </h5>
//                               </Label>
//                               <div className="col-md-10">
//                                 <Field
//                                   className="form-control fs-5"
//                                   name="state"
//                                   as="select"
//                                 >
//                                   <option value="">select</option>
//                                   <option value="Gujarat">Gujarat</option>
//                                   <option value="Maharashtra">
//                                     Maharashtra
//                                   </option>
//                                   <option value="Tamil Nadu">Tamil Nadu</option>
//                                   <option value="Uttar Pradesh">
//                                     Uttar Pradesh
//                                   </option>
//                                   <option value="West Bengal">
//                                     West Bengal
//                                   </option>
//                                   <option value="Karnataka">Karnataka</option>
//                                   <option value="Rajasthan">Rajasthan</option>
//                                   <option value="Andhra Pradesh">
//                                     Andhra Pradesh
//                                   </option>
//                                   <option value="Madhya Pradesh">
//                                     Madhya Pradesh
//                                   </option>
//                                 </Field>
//                               </div>
//                             </div>
//                             <div className="mb-3 row">
//                               <Label
//                                 htmlFor="note"
//                                 className="col-md-2 col-form-label"
//                               >
//                                 <h5 className="text-secondary fw-bold"> User Notes</h5>
//                               </Label>
//                               <div className="col-md-10">
//                               <Field className="form-control fs-5" as="textarea" name="notes" rows="7">
//                               </Field>
//                               </div>
//                             </div>
//                             <div className="col-md-12 text-end">
//                             <Button color="primary" className="fs-4 px-5" type="submit">
//                             Submit
//                           </Button>
//                             </div>

//                           </Row>

//                         </Form>

//                   </CardBody>
//                 </Card>
//               </Col>
//             </Row>
//           </Container>
//         </div>
//       </React.Fragment>
//     );
//   }
// }

// export default ViewUserDetail;
